import { includes, toUpper } from "lodash";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import listingOperations from "../listing/ducks/operations";
import searchOperations from "../search/ducks/operations";
import BrokerDeals from "./BrokerDeals";
import operations from "./ducks/operations";

const BrokerDealsContainer = (props) => {

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "/deals", title: "Broker Deals" });
    }, []);

    return <BrokerDeals {...props} />;
};

const mapStateToProps = (state) => {
    return {
        role: state.authReducer.userProfile.role,
        user: state.authReducer.userProfile.user,
        deals: state.dealsReducer.deals,
        dealView: includes(
            [
                "broker_open",
                "broker_closed",
                "portland_broker_admin",
                "portland_broker_admin_sale",
                "portland_broker_admin_closed",
                "arizona_broker_admin_review",
                "arizona_broker_admin_closed",
            ],
            state.dealsReducer.dealView
        )
            ? state.dealsReducer.dealView
            : "broker_open",
        dealsPage: state.dealsReducer.dealsPage,
        dealsSort: state.dealsReducer.dealsSort,
        dealsFilter: state.dealsReducer.dealsFilter,
        isLoading: state.utilsReducer.isLoading,
        errors: state.utilsReducer.errors,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        switchDealView: (event, value) => {
            dispatch(operations.switchTab(value));
        },
        toggleRequestModal: (spaceType, transactionType) => {
            dispatch(listingOperations.toggleRequestModal(spaceType, transactionType));
        },
        updateSearchTerm: (value, searchType) => {
            dispatch(searchOperations.updateFilter("searchTerm", value, searchType));
        },
        handleSearchSubmit: () => {
            dispatch(searchOperations.executeSearch("property_modal"));
            dispatch(searchOperations.storeSearchRun(true, toUpper("property_modal")));
        },
        searchProperty: (term) => {
            dispatch(searchOperations.searchPropertyAutocomplete(term));
        },
        toggleReviewedBy: (processed, dealKey, tab) => {
            dispatch(operations.toggleReviewedBy(processed, dealKey, tab));
        },
        getDeals: (url, tab) => {
            dispatch(operations.getDeals(url, tab));
        },
        setDealsPage: (page) => {
            dispatch(operations.setDealsPage(page));
        },
        setDealsSort: (sort) => {
            dispatch(operations.setDealsSort(sort));
        },
        setDealsFilter: (filter) => {
            dispatch(operations.setDealsFilter(filter));
        },
        resetDealsTab: () => {
            dispatch(operations.resetDealsTab());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BrokerDealsContainer);
